







import { Component, Vue, Prop } from 'vue-property-decorator';
import { Button } from '@ss/mtd-vue';
import TelsDialog from 'components/common/TelsDialog.vue';

@Component({
  name: 'BtnPhone',
  components: {
    TelsDialog,
    Button,
  },
})
export default class App extends Vue {
  @Prop({ default: () => {} }) readonly params: any;

  @Prop() readonly action: {
    url: string;
  };

  isShow = false;

  onBtnClick() {
    this.isShow = true;
  }

  get telPhones() {
    const telPhones = [];
    this.action && this.action.url && telPhones.push(this.action.url);
    return telPhones;
  }
}
